import { Selector } from '@ngxs/store';
import { UserAgentState } from './user-agent.state';
import { UserAgentStateModel, Browser } from './user-agent-state.model';

export class UserAgentSelectors {
    @Selector([UserAgentState])
    static browser(state: UserAgentStateModel): Browser | null {
        return state.browser
    }
}